module.exports = __webpack_public_path__ + "img/emblem-eth.2a901646.png";